module.exports = __webpack_public_path__ + "static/media/tennis-live.89cda3dc.svg";